export default function getResource(label, vars = []) {
    const resources = {
        free: 'GRATUIT',
        warning: 'Avertissement',
        shippingMethodError: `Malheureusement, nous ne pouvons effectuer l'expédition à votre adresse que par l'entremise de ${vars[0]}. Veuillez sélectionner cette méthode ou choisir une autre adresse sur la feuille Apple Pay.`
    };

    return resources[label];
}
